module.exports = __webpack_public_path__ + "static/media/profilePlaceholder-3.67639f2e.png";